<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label=" 服务网点" prop="nursinghomeId">
              <el-select
                disabled
                v-model="form.nursinghomeId"
                style="width: 100%"
                placeholder="请选择 服务网点"
                @change="nursinghomeIdChange"
              >
                <el-option
                  v-for="item in nursinghomeIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="卡号" prop="cardNo">
              <el-input
                clearable
                :disabled="model === 'view'"
                v-model="form.cardNo"
                placeholder="请输入卡号"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" >
            <el-form-item label="老人姓名" prop="name" >
             
              <el-input
                clearable
              readonly
                v-model="form.name"
                placeholder="请选择老人"
                maxlength="50"
              >
              
              <template  slot="append" ><div @click="choiceUser">选择</div></template>
            </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="身份证号" prop="idNumber">
              <el-input
                clearable
                disabled
                v-model="form.idNumber"
              
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="性别" prop="sex">
              <el-select disabled v-model="form.sex"   placeholder=" " style="width: 100%" >
              <el-option
                v-for="(item, index) in sexList"
                :key="index"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
            </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align: right" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model === 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
    <hr-dialog
      title="老人列表"
      :allowFull="false"
      width="60%"
      @close="closeAddOldManDialog"
      :visible.sync="choiceUserVisible"
    >
      <template slot="body">
        <chocieOldPeopleVue
          v-if="choiceUserVisible"
          :nursinghomeId="form.nursinghomeId"
          @getData="getData"
        ></chocieOldPeopleVue>
      </template>
    </hr-dialog>
  </div>
</template>
<script>
import { getDictionary } from '@/api/common.js';
import { getNursinghome } from '../api/serveItemManage';
import {smartcardsave } from '@/api/nursingHome/nursingCard';
import chocieOldPeopleVue from './chocieOldPeople.vue';
export default {
  components: { chocieOldPeopleVue },
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      sexList: [],
      projectList: [],
      choiceUserVisible: false,
      form: {
        nursinghomeId: '',
        name: '',
        idNumber: '',
        sex: '',
      },
      formRules: {
        nursinghomeId: [{ required: true, message: ' 服务网点不能为空', trigger: 'change' }],
        name: [{ required: true, message: '老人名称不能为空', trigger: 'change' }],
        cardNo: [{ required: true, message: '卡号不能为空', trigger: 'blur' }],
      },
      selfCareConditionList: [],
      relationshipList: [],
      consultWayTypeList: [],
      mediaChannelTypeList: [],
      consultTypeList: [],
      nursinghomeIdList: [],
    };
  },
  created() {
    console.log(this.model);
    console.log(this.row);
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    choiceUser() {
      console.log('--');
      this.choiceUserVisible = true;
    },
    getData(data) {
      console.log(data.id)
      if(data.id!=undefined){
        this.form.name= data.name
      this.form.idNumber= data.idNumber
      this.form.sex= data.sex
      this.form.liveUserId= data.id
      }
      this.choiceUserVisible = false;
    },
    async initData() {
      getDictionary("sex").then(res=>{
        this.sexList = res.data
      })
      getNursinghome({ id: this.nursinghomeId }).then((res) => {
        this.nursinghomeIdList = res.data;
        this.form.nursinghomeId = this.nursinghomeId;
      });
      if (this.model !== 'add') {
      }

     
    },
    saveRecord() {
      if (this.model === 'add') {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            smartcardsave(this.form).then((res) => {
              this.$message.success('新增成功');
              this.$emit('success');
            });
          }
        });
      } else {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            stockWarnUpdate(this.form).then((res) => {
              this.$message.success('修改成功');
              this.$emit('success');
            });
          }
        });
      }
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
